import { marksCellWidth } from './common';
import { sortParams } from '../../../constants/common';

export const columns = [
  {
    key: 'marks',
    width: `${marksCellWidth}px`,
  },
  {
    key: 'num/create',
    width: `13%`,
    title: '№/Создание',
    sort: true,
  },
  {
    key: 'status',
    width: `10%`,
    title: 'Статус',
    sort: true,
  },
  {
    key: 'master/executer',
    width: `16%`,
    title: 'Мастер/Исполнитель',
    sort: true,
  },
  {
    key: 'parentService/service',
    width: `19%`,
    title: 'Услуга/Причина',
    sort: true,
  },
  {
    key: 'done',
    width: `20%`,
    title: 'Выполнение',
    sort: true,
  },
  {
    key: 'address',
    width: `18%`,
    title: 'Адрес',
    sort: true,
  },
];
